import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CloseIcon from "@mui/icons-material/Close";
import AddPortalRule from "../../../compenents/Setting/Portal Setting Rules/AddPortalRule";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  PortalSettingRule,
  RuleActionType,
} from "../../../models/features/ShopifySetting/Portal Setting Rules/PortalSettingRules";
import {
  useGetShoppingPortalRulesQuery,
  usePortalRulesActionMutation,
} from "../../../redux/reducer/features/Setting/Shopping Portal/ShoppingPortalSettingSlice";

function PortalSettingRules() {
  const { data, isLoading, refetch } = useGetShoppingPortalRulesQuery();
  const [ruleActionMutation, ruleActionMutationResult] =
    usePortalRulesActionMutation();
  const [settingRules, setSettingRules] = React.useState<PortalSettingRule[]>(
    []
  );
  const [open, setOpen] = React.useState(false);
  const [selectedRule, setSelectedRule] = React.useState<
    PortalSettingRule | undefined
  >();

  const handleClose = (fetch: boolean) => {
    setSelectedRule(undefined);
    setOpen(false);
    if (fetch) {
      refetch();
    }
  };

  const handleDeleteOrDisableRule = (actionType: RuleActionType, id: any) => {
    if (actionType === RuleActionType.Delete) {
      let rules = settingRules.filter((rule: any) => rule.id !== id);
      setSettingRules(rules);
    } else if (actionType === RuleActionType.Enable) {
      let rules = settingRules.map((rule) =>
        rule.id === id ? { ...rule, status: true } : rule
      );
      setSettingRules(rules);
    } else if (actionType === RuleActionType.Disable) {
      let rules = settingRules.map((rule) =>
        rule.id === id ? { ...rule, status: false } : rule
      );
      setSettingRules(rules);
    }
    ruleActionMutation({ data: { id: id, actionType: actionType } }).then(
      (res) => {
        console.log("resopnse", res);
      }
    );
  };
  React.useEffect(() => {
    if (data && data.status === 200) {
      console.log("Setting Rules", data);
      setSettingRules(data.entityList ?? []);
    }
  }, [data]);

  return (
    <Container maxWidth={false}>
      <Box sx={{ flexGrow: 1, pb: 2 }}>
        <Grid container spacing={8}>
          <Grid item xs={4}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
              Portal Setting Rules
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Grid container sx={{ justifyContent: "right" }} spacing={2}>
              <Grid item>
                <Button
                  color="warning"
                  variant="contained"
                  onClick={() => setOpen(true)}
                >
                  Add Rule
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <Card sx={{ borderRadius: 3 }}>
        <CardContent sx={{ minHeight: "60vh" }}>
          <Typography
            sx={{
              fontSize: "1rem",
              fontWeight: 600,
            }}
          >
            Portal Rules
          </Typography>
          <Typography
            sx={{
              fontSize: "0.875rem",
              color: "#6d7175",
            }}
          >
            Add or update Portal Setting Rules for hiding prices and cart
            buttons of Parts on Shopping Portal.
          </Typography>
          <Divider sx={{ borderBottomWidth: 1, mt: 2, mb: 2 }} />
          {isLoading ? (
            <CircularProgress
              sx={{ ml: "50%", mt: "10%" }}
              size="2.8rem"
              color="inherit"
            />
          ) : (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Rule Title</TableCell>
                    <TableCell align="center">Hide Price</TableCell>
                    <TableCell align="center">Hide Cart</TableCell>
                    <TableCell align="center">Enable</TableCell>
                    <TableCell align="center">Status</TableCell>
                    <TableCell align="center">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {settingRules && settingRules.length > 0 ? (
                    settingRules.map((rule) => (
                      <TableRow
                        key={rule.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell align="left">{rule.settingTitle}</TableCell>
                        <TableCell align="center">
                          {rule.hidePrice ? "YES" : "NO"}
                        </TableCell>
                        <TableCell align="center">
                          {rule.hideCartButton ? "YES" : "NO"}
                        </TableCell>
                        <TableCell align="center">
                          {" "}
                          <Switch
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            checked={rule.status}
                            size="small"
                            name="status"
                            onChange={(e) => {
                              if (e.target.checked === true) {
                                handleDeleteOrDisableRule(
                                  RuleActionType.Enable,
                                  rule.id
                                );
                              } else if (e.target.checked === false) {
                                handleDeleteOrDisableRule(
                                  RuleActionType.Disable,
                                  rule.id
                                );
                              }
                            }}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                        </TableCell>

                        <TableCell align="center">
                          {" "}
                          <Chip
                            size="small"
                            color={rule.status ? "success" : "error"}
                            label={rule.status ? "Enabled" : "Disabled"}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <IconButton
                            onClick={() =>
                              handleDeleteOrDisableRule(
                                RuleActionType.Delete,
                                rule?.id
                              )
                            }
                            color="error"
                            aria-label="delete"
                          >
                            <DeleteIcon />
                          </IconButton>
                          |
                          <IconButton
                            onClick={() => {
                              setSelectedRule(rule);
                              setOpen(true);
                            }}
                            color="primary"
                            aria-label="edit"
                          >
                            <EditIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableCell colSpan={6}>
                      <Typography
                        sx={{ width: "100%", textAlign: "center", mt: 10 }}
                      >
                        No Rules to Show
                      </Typography>
                    </TableCell>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </CardContent>
      </Card>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        aria-labelledby="draggable-dialog-title"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBottom: 0,
          }}
        >
          <Typography sx={{ fontSize: "22px", fontWeight: "bold" }}>
            Rule Setup
          </Typography>
          <IconButton
            onClick={() => {
              handleClose(false);
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ height: "auto" }}>
          <AddPortalRule settingRule={selectedRule} handleClose={handleClose} />
        </DialogContent>
      </Dialog>
    </Container>
  );
}

export default PortalSettingRules;
